<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-4">
    <h2>Consulta Geral</h2>
    <h3>Programa</h3>
  </div>
  <div class="col-lg-8 d-flex justify-content-end d-wrap">
    <div class="search">
      <input type="text" class="form-control" aria-describedby="basic-addon1" [(ngModel)]="filter_pesquisa" (keyup)="pesquisar()" autocomplete="off">
      <span class="icon-search" id="basic-addon1">
        <img src="assets/images/svgs/pesquisa.svg" alt="Pesquisar">
      </span>
    </div>
    <div class="new-project" *ngIf="canCreate">
      <a class="btn btn-primary" type="btn" [routerLink]="novo()">Novo</a>
    </div>
  </div>
</div>

<div class="open-filters" *ngIf="!filterActive">
  <button class="btn-filters-close" type="button" (click)="advancedSearch()">
    <img src="assets/images/svgs/Filtros.svg">
  </button>
</div>

<div *ngIf="filterActive" class="wrapper wrapper-content animated fadeInRight" [@slideIn]="filterActive">
  <div class="row">
    <div class="col-12">
      <div class=" float-e-margins">
        <div class="form_search">
          <div class="m-b">
            <div class="form-group form-filter">
              <h3>Filtros</h3>
              <div class="col-8 d-flex justify-content-end">
                <button class="btn-filters" type="button" (click)="cleanSearch()">
                  <img src="assets/images/svgs/Limpar_filtros.svg">
                  <span>Limpar Filtros</span>
                </button>
                <button class="btn-filters-close" type="button" (click)="closeFilter()">
                  <img src="assets/images/svgs/Fechar.svg" alt="Pesquisar">
                </button>
              </div>
            </div>
          </div>
          <form [formGroup]="form">
            <div class="form-group row">
              <div class="col-sm-6 m-b">
                <label class="col-sm-12 pb-1">Programa</label>
                <ng-select id="filter_pg_type1" class="ng-select-alternative" [items]="programaList" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_pg_type1">
                </ng-select>
              </div>

              <div class="col-sm-6 m-b">
                <label class="col-sm-12 pb-1">Órgão do Projeto Agregador</label>
                <ng-select id="filter_agency_pg_type2" class="ng-select-alternative" [items]="orgaoList" [multiple]="true" bindLabel="str_nome" bindValue="num_codigo_pk" placeholder="Todos" formControlName="filter_agency_pg_type2">
                </ng-select>
              </div>
            </div>
            
            <div class="form-group row">
              <div class="col-sm-6 m-b">
                <label class="col-sm-12 pb-1">Projeto Agregador</label>
                <ng-select id="filter_pg_type2" class="ng-select-alternative" [items]="agregadorList" bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_pg_type2">
                </ng-select>
              </div>

              <div class="col-sm-1 m-b">
                <label class="col-sm-12 pb-1">Ativo</label>
                <ng-select id="filter_actived" class="ng-select-alternative" [items]="simNaoList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="filter_actived">
                </ng-select>
              </div>

              <div class="col-sm-12 m-b">
                <div class="search-button">
                  <button type="button" (click)="search()">Filtrar</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="system-table">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th class="title-agregador">Programa</th>
          <th>Órgão</th>
          <th class="text-center btn-icon-td">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let programa of listaPesquisa">
          <tr>
            <td class="title">
              <span class="title-span">{{programa?.title}}</span>
              <div class="responsavel">
                <img *ngIf="programa?.resp_nome" src="assets/images/svgs/responsavel.svg" alt="Responsavel" [tooltip]="programa?.resp_nome" placement="bottom" (click)="viewResonsavel(programa)">
              </div>
            </td>
            <td>{{programa?.agency_name}}</td>
            <td>
              <div class="btn-icon">
                <a class="icon-table" [routerLink]="editarClickHandler(programa)">
                  <img src="assets/images/svgs/lupa.svg" tooltip="Visualizar" placement="bottom">
                </a>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!listaPesquisa?.length" class="border-b-radius">
          <td colspan="7" class="text-center">Nenhum Programa Encontrado.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>
<app-modal-responsavel #modalResonsavel></app-modal-responsavel>